import {
  Briefcase, Shield, Car, TrendingUp,
  Home, CreditCard, Banknote, Building2, PieChart, Wrench, Users, Globe, Scale
} from "lucide-react";

// All industry types — single source of truth used by USMap, ClaimZip, PartnerPortal
// Order reflects real-world tax-season demand priority
export const INDUSTRY_TYPES = [
  {
    value: "all",
    label: "All Industries",
    icon: Globe,
    color: "#64748b",
    bg: "bg-slate-700",
    desc: "",
    border: "border-slate-400",
  },
  {
    value: "tax_pro",
    label: "Tax Professional",
    icon: Briefcase,
    color: "#2ECC71",
    bg: "bg-emerald-900/40",
    desc: "Tax preparation & refund advances",
    border: "border-[#2ECC71]",
  },
  {
    value: "legal_help",
    label: "Legal Help / Tax Lawyer",
    icon: Scale,
    color: "#6366f1",
    bg: "bg-indigo-900/40",
    desc: "Tax law, IRS defense & legal representation",
    border: "border-indigo-400",
  },
  {
    value: "debt_relief",
    label: "Debt Relief",
    icon: CreditCard,
    color: "#f43f5e",
    bg: "bg-rose-900/40",
    desc: "Debt settlement & credit repair",
    border: "border-rose-400",
  },
  {
    value: "insurance",
    label: "Insurance Agent",
    icon: Shield,
    color: "#38bdf8",
    bg: "bg-sky-900/40",
    desc: "Auto, home, life & health insurance",
    border: "border-sky-400",
  },
  {
    value: "retirement_planner",
    label: "Retirement Planner",
    icon: TrendingUp,
    color: "#a78bfa",
    bg: "bg-violet-900/40",
    desc: "Financial planning & retirement advice",
    border: "border-violet-400",
  },
  {
    value: "financial_advisor",
    label: "Financial Advisor",
    icon: PieChart,
    color: "#06b6d4",
    bg: "bg-cyan-900/40",
    desc: "Wealth management & investing",
    border: "border-cyan-400",
  },
  {
    value: "personal_loan",
    label: "Personal Loan",
    icon: Banknote,
    color: "#facc15",
    bg: "bg-yellow-900/40",
    desc: "Personal loans & check cashing",
    border: "border-yellow-400",
  },
  {
    value: "real_estate",
    label: "Real Estate Agent",
    icon: Building2,
    color: "#84cc16",
    bg: "bg-lime-900/40",
    desc: "Home buying, selling & investing",
    border: "border-lime-400",
  },
  {
    value: "mortgage_broker",
    label: "Mortgage Broker",
    icon: Home,
    color: "#14b8a6",
    bg: "bg-teal-900/40",
    desc: "Home loans, purchase & refinancing",
    border: "border-teal-400",
  },
  {
    value: "home_improvement",
    label: "Home Improvement",
    icon: Wrench,
    color: "#fb923c",
    bg: "bg-amber-900/40",
    desc: "Home renovations & contractors",
    border: "border-amber-400",
  },
  {
    value: "auto_dealer",
    label: "Auto Dealer",
    icon: Car,
    color: "#f97316",
    bg: "bg-orange-900/40",
    desc: "New & used vehicle sales & service",
    border: "border-orange-400",
  },
  {
    value: "job_posting",
    label: "Job Posting",
    icon: Users,
    color: "#e879f9",
    bg: "bg-fuchsia-900/40",
    desc: "Local job opportunities & hiring",
    border: "border-fuchsia-400",
  },
];

// Fast lookup by value
export const INDUSTRY_MAP = Object.fromEntries(
  INDUSTRY_TYPES.filter(t => t.value !== "all").map(t => [t.value, t])
);

// Get a single industry by value (defaults to tax_pro if unknown)
export function getIndustryType(value) {
  return INDUSTRY_MAP[value] || INDUSTRY_MAP["tax_pro"];
}

// All industry values except "all"
export const INDUSTRY_VALUES = INDUSTRY_TYPES.filter(t => t.value !== "all").map(t => t.value);
